module.exports = __webpack_public_path__ + "img/icon-gallery-white.ebd6566f.svg";